// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.staff-swiper-container .swiper');

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 16,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 4,
            },
        });
    });
});